import React from "react";

import Classes from "classnames";
import {ViewTypeConfigs, ViewTypeSystemConfig} from "../../../../../gd/const/views/view-type-config";
import {ViewType} from "../../../../../gd/const/views/view-type";

type Props = {
    view       : any
    isSelected : boolean
    onClick    : callback
}

export default class SearchViewOption extends React.Component<Props> {

    onClick = (view: ViewTypeSystemConfig) => {
        this.props.onClick && this.props.onClick(this.props.view.id, view.url)
    }

    render() {
        const classes = Classes("row", "ui5-list-item", {
            'selected': this.props.isSelected,
        });

        const view = ViewTypeConfigs[this.props.view.type as ViewType]!

        return (
            <div className={classes} onClick={()=>{this.onClick(view)}}>
                <div className="cell">
                    <div className="title">
                        <div className="icon-22 m-r-10">
                            <div className={Classes("ui5-ico-16", view.icon)}/>
                        </div>
                        <div className="ui5-txt-default max-w-250">{this.props.view.name}</div>
                    </div>
                </div>
                <div className="cell align-r"/>
            </div>
        )

        /*return (
            <div className={classes} onClick={this.onClick}>
                <div className={Classes("search-item-icon", "view-icon", ViewTypeConfig[this.props.view.boardType].icon)}> </div>
                <div className="search-item-details">
                    <div className="search-item-title">{this.props.view.name}</div>
                    {this.props.showCompany && this.props.view.companyId && <div className="search-item-company">{gd.session.companies.get(this.props.view.companyId).name}</div>}
                </div>
                <div className="cf"/>
            </div>
        );*/
    }
}
